module.exports = __webpack_public_path__ + "static/media/floor_default.df5df2a8.png";